<template>
  <div style="margin-top:20px">
    <el-form ref="form" label-width="80px" :model="form">
      <el-row>
        <el-form-item label="code" style="margin-right:15px">
          <el-input v-model="form.code" :disabled="true" />
        </el-form-item>
        <el-form-item label="支付油点（单位分）" style="margin-right:15px">
          <el-input v-model="form.payPoint" :disabled="true" />
        </el-form-item>
        <el-form-item label="实际承运人用户编码" style="margin-right:15px">
          <el-input v-model="form.driverCode" :disabled="true" />
        </el-form-item>
        <el-form-item label="加油站编码" style="margin-right:15px">
          <el-input v-model="form.gsaCode" :disabled="true" />
        </el-form-item>
        <el-form-item label="小票号" style="margin-right:15px">
          <el-input v-model="form.banks" :disabled="true" />
        </el-form-item>
        <el-form-item label="设备号" style="margin-right:15px">
          <el-input v-model="form.deviceNumber" :disabled="true" />
        </el-form-item>
        <el-form-item
          label="实际承运人余额（单位分）"
          style="margin-right:15px"
        >
          <el-input v-model="form.balanceOil" :disabled="true" />
        </el-form-item>
        <el-form-item label="商户名称" style="margin-right:15px">
          <el-input v-model="form.merchantName" :disabled="true" />
        </el-form-item>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import request from "@/utils/request";
export default {
  name: "GasStationPaymentDetail",
  data() {
    return {
      emptyForm: {},
      form: {
        code: "",
        payPoint: "",
        driverCode: "",
        gsaCode: "",
        banks: "",
        deviceNumber: "",
        balanceOil: "",
        merchantName: ""
      }
    };
  },
  created() {
    //保存空表单对象
    this.emptyForm = JSON.parse(JSON.stringify(this.form));
  },
  methods: {
    // 获取页面信息
    getInfo(code) {
      //查询到数据之前先展示空表单
      this.form = JSON.parse(JSON.stringify(this.emptyForm));
      request({
        url: `/ntocc-basic-api/gasStationPayment/${code}`,
        method: "get"
      }).then(response => {
        this.form = response.data;
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.dialog-footer {
  margin-top: 50px;
}
</style>
